export default __webpack_public_path__ + "assets/static/data/app.model.3001b2c6dad1e256be3635416c514271.json";